export default __webpack_public_path__ + "static/media/paint-palette.a42e4686.png";